"use client";
import {
  CollectionContextProvider,
  CollectionScopedContextProvider
} from "./VDHZ5F7K.js";
import {
  createStoreContext
} from "./LMDWO4NN.js";

// src/form/form-context.tsx
var ctx = createStoreContext(
  [CollectionContextProvider],
  [CollectionScopedContextProvider]
);
var useFormContext = ctx.useContext;
var useFormScopedContext = ctx.useScopedContext;
var useFormProviderContext = ctx.useProviderContext;
var FormContextProvider = ctx.ContextProvider;
var FormScopedContextProvider = ctx.ScopedContextProvider;

export {
  useFormContext,
  useFormScopedContext,
  useFormProviderContext,
  FormContextProvider,
  FormScopedContextProvider
};
